var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"root-layout"}},[(_vm.isLoggedIn)?_c('Header'):_vm._e(),_c('div',{class:['page-wrapper', _vm.shouldDisplayCover && 'bg-cover']},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }